import { createAction } from 'redux-actions';
import {
  createActionWithNestedPagination,
  generatePaginators,
  getPaginator,
} from 'utils/pagination';
import { topic, post as topicPost } from 'api/schema';
import queryString from 'query-string';
import keys from 'lodash/keys';
import * as Api from 'api/forum';
import { history } from 'store';

const topicsPaginatorURI = '/v1/places/{id}/forum/topics';
const topicsPaginatorEntity = [topic];
const topicsPaginators = generatePaginators(
  topicsPaginatorURI,
  topicsPaginatorEntity,
);

const requestTopics = createAction('TOPICS_REQUEST');
const receiveTopics = createActionWithNestedPagination('TOPICS_SUCCESS');
const failTopics = createAction('TOPICS_ERROR');

export const getTopics = (placeId, query = '') => dispatch => {
  dispatch(requestTopics());

  const paginator = getPaginator(
    topicsPaginators,
    placeId,
    topicsPaginatorURI,
    topicsPaginatorEntity,
    20,
  );

  const parsedQuery = queryString.parse(query);

  keys(parsedQuery).forEach(key => {
    paginator.set(key, parsedQuery[key]);
  });

  return paginator
    .get()
    .then(
      data => dispatch(receiveTopics({ placeId, data })),
      error => dispatch(failTopics(error)),
    );
};

const requestTopicCategories = createAction('TOPIC_CATEGORIES_REQUEST');
const receiveTopicCategories = createAction('TOPIC_CATEGORIES_SUCCESS');
const failTopicCategories = createAction('TOPIC_CATEGORIES_ERROR');

export const getTopicCategories = placeId => dispatch => {
  dispatch(requestTopicCategories(placeId));

  return Api.getTopicCategories(placeId).then(
    data => dispatch(receiveTopicCategories({ placeId, data })),
    error => dispatch(failTopicCategories(error)),
  );
};

const requestTopic = createAction('TOPIC_REQUEST');
const receiveTopic = createAction('TOPIC_SUCCESS');
const failTopic = createAction('TOPIC_ERROR');

export const getTopic = topicId => dispatch => {
  dispatch(requestTopic(topicId));

  return Api.getTopic(topicId).then(
    data => dispatch(receiveTopic(data)),
    error => dispatch(failTopic(error)),
  );
};

const topicPostsPaginatorURI = '/v1/forum/topics/{id}/posts';
const topicPostsPaginatorEntity = [topicPost];
const topicPostsPaginators = generatePaginators(
  topicPostsPaginatorURI,
  topicPostsPaginatorEntity,
);

const requestTopicPosts = createAction('TOPIC_POSTS_REQUEST');
const receiveTopicPosts = createActionWithNestedPagination(
  'TOPIC_POSTS_SUCCESS',
);
const failTopicPosts = createAction('TOPIC_POSTS_ERROR');

export const getTopicPosts = (topicId, query = '') => dispatch => {
  dispatch(requestTopicPosts());

  const paginator = getPaginator(
    topicPostsPaginators,
    topicId,
    topicPostsPaginatorURI,
    topicPostsPaginatorEntity,
    15,
  );

  const parsedQuery = queryString.parse(query);

  keys(parsedQuery).forEach(key => {
    paginator.set(key, parsedQuery[key]);
  });

  return paginator
    .get()
    .then(
      data => dispatch(receiveTopicPosts({ topicId, data })),
      error => dispatch(failTopicPosts(error)),
    );
};
//
// const requestTopicPosts = createAction('TOPIC_POSTS_REQUEST');
// const receiveTopicPosts = createAction('TOPIC_POSTS_SUCCESS');
// const failTopicPosts = createAction('TOPIC_POSTS_ERROR');
//
// export const getTopicPosts = topicId => dispatch => {
//   dispatch(requestTopicPosts(topicId));
//
//   return Api.getTopicPosts(topicId).then(
//     data => dispatch(receiveTopicPosts({ topicId, data })),
//     error => dispatch(failTopicPosts(error)),
//   );
// };

const requestCreateTopic = createAction('NEW_TOPIC_REQUEST');
const receiveCreateTopic = createAction('NEW_TOPIC_SUCCESS');
const failCreateTopic = createAction('NEW_TOPIC_ERROR');

export const createTopic = (placeId, payload) => dispatch => {
  dispatch(requestCreateTopic(placeId));

  return Api.createTopic({ placeId, payload }).then(
    data => {
      dispatch(receiveCreateTopic({ placeId, data }));
      history.push(`/mes-echanges/forum/${data.result}`);
    },
    error => dispatch(failCreateTopic(error)),
  );
};

const requestArchiveTopic = createAction('ARCHIVE_TOPIC_REQUEST');
const receiveArchiveTopic = createAction('ARCHIVE_TOPIC_SUCCESS');
const failArchiveTopic = createAction('ARCHIVE_TOPIC_ERROR');

export const archiveTopic = topicId => dispatch => {
  dispatch(requestArchiveTopic(topicId));

  return Api.archiveTopic({ topicId }).then(
    data => dispatch(receiveArchiveTopic(data)),
    error => dispatch(failArchiveTopic(error)),
  );
};

const requestUnarchiveTopic = createAction('UNARCHIVE_TOPIC_REQUEST');
const receiveUnarchiveTopic = createAction('UNARCHIVE_TOPIC_SUCCESS');
const failUnarchiveTopic = createAction('UNARCHIVE_TOPIC_ERROR');

export const unarchiveTopic = topicId => dispatch => {
  dispatch(requestUnarchiveTopic(topicId));

  return Api.unarchiveTopic({ topicId }).then(
    data => dispatch(receiveUnarchiveTopic(data)),
    error => dispatch(failUnarchiveTopic(error)),
  );
};

const requestCreatePost = createAction('NEW_POST_REQUEST');
const receiveCreatePost = createAction('NEW_POST_SUCCESS');
const failCreatePost = createAction('NEW_POST_ERROR');

export const createPost = ({ topicId, payload }) => dispatch => {
  dispatch(requestCreatePost(topicId));

  return Api.createPost({ topicId, payload }).then(
    data => dispatch(receiveCreatePost({ topicId, data })),
    error => dispatch(failCreatePost(error)),
  );
};

const requestUpdateTopic = createAction('UPDATE_TOPIC_REQUEST');
const receiveUpdateTopic = createAction('UPDATE_TOPIC_SUCCESS');
const failUpdateTopic = createAction('UPDATE_TOPIC_ERROR');

export const updateTopic = ({ topicId, payload }) => dispatch => {
  dispatch(requestUpdateTopic(topicId));

  return Api.updateTopic({ topicId, payload }).then(
    data => dispatch(receiveUpdateTopic({ topicId, data })),
    error => dispatch(failUpdateTopic(error)),
  );
};

const requestUpdatePost = createAction('UPDATE_POST_REQUEST');
const receiveUpdatePost = createAction('UPDATE_POST_SUCCESS');
const failUpdatePost = createAction('UPDATE_POST_ERROR');

export const updatePost = ({ postId, payload }) => dispatch => {
  dispatch(requestUpdatePost(postId));

  return Api.updatePost({ postId, payload }).then(
    data => dispatch(receiveUpdatePost({ postId, data })),
    error => dispatch(failUpdatePost(error)),
  );
};
